var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "dealer-keyword-search form-group" }, [
    _c(
      "label",
      {
        staticClass: "dealer-keyword-search__filter__label form__label",
        attrs: { for: "dealer-keyword-search__keyword-name" },
      },
      [_vm._v(_vm._s(_vm.$t("global-dealer-search.keyword")))]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "dealer-keyword-search__input--suggestions-wrapper" },
      [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.keyword,
              expression: "keyword",
            },
          ],
          staticClass: "form__input form__input--text",
          attrs: { id: "dealer-keyword-search__keyword-name", type: "text" },
          domProps: { value: _vm.keyword },
          on: {
            keyup: function ($event) {
              $event.preventDefault()
              return _vm.setSuggestion.apply(null, arguments)
            },
            focus: function ($event) {
              _vm.selected = false
            },
            input: function ($event) {
              if ($event.target.composing) return
              _vm.keyword = $event.target.value
            },
          },
        }),
        _vm._v(" "),
        _vm.suggestions.length && !_vm.selected
          ? [
              _c(
                "div",
                { staticClass: "dealer-keyword-search__input--suggestion" },
                [
                  _vm._l(
                    _vm.suggestions.slice(0, this.maxSuggestions),
                    function (suggestion, index) {
                      return [
                        _c(
                          "p",
                          {
                            class:
                              _vm.highlightedSuggestion === index
                                ? "dealer-keyword-search__suggestion--active"
                                : "",
                            on: {
                              click: function ($event) {
                                return _vm.setKeyword(index)
                              },
                            },
                          },
                          [
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.highlightSuggestion(suggestion)
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "(" +
                                  _vm._s(suggestion.dealerships.length) +
                                  ")"
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        index === _vm.maxSuggestions - 1 &&
                        index < _vm.suggestions.length
                          ? [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "dealer-keyword-search__show-more",
                                  on: {
                                    click: function ($event) {
                                      _vm.maxSuggestions += 5
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$t("global-dealer-search.loadMore")
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ]
                          : _vm._e(),
                      ]
                    }
                  ),
                ],
                2
              ),
            ]
          : _vm._e(),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "button-wrapper right" },
      [
        _c(
          "global-button",
          {
            attrs: { theme: "primary" },
            on: {
              click: function ($event) {
                return _vm.searchByKeyword()
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("global-dealer-search.button.search")))]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }